import React, { useState } from 'react';
import styled from '@emotion/styled';
import { DatePicker } from '../../shared/components/date-picker/DatePicker';
import { MaybeDate } from '../../shared/components/date-picker/MaybeDate';

export const DatePickers = () => {
	const [date, setDate] = useState<MaybeDate>(null);
	const [range, setRange] = useState<[MaybeDate, MaybeDate]>([null, null]);

	return (
		<Wrap>
			<h2 id="date-picker">Date Picker</h2>

			<Row>
				<DatePicker
					selected={date}
					onChange={setDate}
					placeholderText="Select date"
				/>
			</Row>
			<Row>
				<DatePicker
					selectsRange
					selected={range}
					onChange={setRange}
					placeholderText="Select date range"
				/>
			</Row>
		</Wrap>
	);
};

const Wrap = styled.div`
	max-width: 600px;
`;

const Row = styled.div`
	& ~ & {
		margin-top: 24px;
	}
`;
